import { BusniessUnit } from "./Branch";
import { MeasurementUnit } from "./MeasurementUnit";

export enum CateringRecipeType {
  MENU_ITEM = "MENU_ITEM",
  SUB_RECIPE = "SUB_RECIPE",
}

// Mirrors backend CateringRecipe (com.minesweepers.pojos.models.CateringRecipe).
export interface ICateringRecipe {
  id: string;
  name: string;
  businessUnit: BusniessUnit;
  type: CateringRecipeType;
  unitOfMeasure: MeasurementUnit;
  yieldQuantity: number;
  // Ingredient id -> qty. Id may refer to a Material (raw) or another CateringRecipe.
  ingredients: Record<string, number>;
  creationTime: number;
}
